$(document).ready(function(){


/***************** MAP GLOBALS *****************/
var width = '100%',
    height = '100%',
    scale = 1,
    projection = d3.geoAlbersUsa(),
    newURL = window.location.protocol + "//" + window.location.host,
    path = d3.geoPath(),
    currentMousePos = { x: -1, y: -1 }
    isHomePage = false;
   
    /* Map Translation Variables (Homepage Only) */
    var dragTranslateX = 0,
        dragTranslateY = 0,
        currentTranslatedX = 0,
        currentTranslatedY = 0,
        storedXValue = 0,
        storedYValue = 0
        maps = {};

    var drag_behavior = d3.drag()
                          .on("start", dragstarted)
                          .on("drag", dragged)
                          .on("end", mouseUp);

    if($('body').hasClass('page-template-page-home')) {
      isHomePage = true;
    }


/***************** MAP CONSTRUCTION *****************/

var d3EachMap = function() {
  /* If user adds more than 1 map to a page */
  if($(".map-container").length > 1) {
    var count = 1;  

    $(".map-container").each(function(){
      var prevId = $(this).attr('id')+'-';
      $(this).attr('id', prevId + count );
      constructMap($(this).attr('id'));
      count++;
    });

  } else {
    constructMap('svgContainer');
  }
}

var constructMap = function(mapContainer) {

  maps[mapContainer] = d3.select('#'+ mapContainer).append("svg")
    .attr("viewBox",'-30 0 1000 600')
    .attr("width", width)
    .attr("height", height);

  /* Constructing Containers*/
  var outerG = maps[mapContainer].append("g")
                                 .attr("id","outer-g");

  var extraClasses = '';

  if($('#'+ mapContainer).hasClass('pre-filtered')) {
    extraClasses = ' pre-filtered '+ $('#'+ mapContainer).data('community-type');
  }

  /* Adding Data to Map */
  d3.json(newURL + "/wp-content/themes/AmericanCommunitiesProject/data/processed-county-data.json", function(error, us) {
    if (error) throw error;

    if(isHomePage) {
      /* Counties SVG */
    var gCounties = outerG.append("g")
      .attr('class', 'counties'+extraClasses)
      .attr('id', 'counties')
      .attr('style','transform-origin:center center')
      .selectAll("path")
      .data(topojson.feature(us, us.objects.counties).features)
      .enter().append("path")
      .attr("d", path)
      .attr('class', function(d){
          return assignCommunity(d.properties['community']);
      })
      .attr("stroke", "white")
      .attr("stroke-width", .25)
      .on("mouseover",hovering)
      .on("click", clicked);

      if ( ((navigator.userAgent.indexOf("Chrome") !== -1) ) && (navigator.userAgent.indexOf("Edge") == -1) ){
        gCounties.call(drag_behavior);
        $('#pan-toggles').attr("style","display: none;");      
      }
      
      if ( (navigator.userAgent.indexOf("Edge") !== -1)) {
          $('#pan-toggles').attr("style","display: block;"); 
      }

    /* State Borders SVG */
    var gStates = outerG.append("g")
        .attr("class", "state-borders")
        .attr('id', 'states')
        .attr('style','transform-origin:center center; pointer-events: none;')
        .selectAll("path")
        .data(topojson.feature(us, us.objects.states).features)
        .enter().append("path")
        .attr("d", path)
        .attr("fill","transparent")
        .attr("stroke", "white")
        .attr("stroke-width", 1);
    }
    else {
      /******** IF NOT HOMEPAGE DONT ADD INTERACTIVITY TO MAP *********/

      /* Counties SVG */
      maps[mapContainer].append("g")
        .attr('class', 'counties'+extraClasses)
        .attr('id', 'counties')
        .attr('style','transform-origin:center center')
        .selectAll("path")
        .data(topojson.feature(us, us.objects.counties).features)
        .enter().append("path")
        .attr("d", path)
        .attr('class', function(d){
            return assignCommunity(d.properties['community']);
        })
        .attr("stroke", "white")
        .attr("stroke-width", .25);


      /* State Borders SVG */
      maps[mapContainer].append("g")
          .attr("class", "state-borders")
          .attr('id', 'states')
          .attr('style','transform-origin:center center; pointer-events: none;')
          .selectAll("path")
          .data(topojson.feature(us, us.objects.states).features)
          .enter().append("path")
          .attr("d", path)
          .attr("fill","transparent")
          .attr("stroke", "white")
          .attr("stroke-width", 1);
    }

  });
}

  var assignCommunity = function(communityType) {
    if(communityType) {
      return communityType.toLowerCase().replace(/ /g, '-');
    }
    return "";
  }


/***************** MAP BEHAVIORS *****************/

  /* CLICK */
  function clicked(d) {
    if ($(window).width() >= 900) {
      window.location.href = communityDescriptions[d.properties.community+' Url'];
    }
  }

  /* ZOOM */
  function zoomIn() {
    if( scale <= 4 ) { 
      var translateX = ($('#svgContainer').width()/2)/2;
      scale = scale + .25;

      var transformations = "scale("+scale+")";
      $('g#outer-g').attr("transform", transformations);
    }
  }

  function zoomOut() {
    if( scale > 1 ) { 
      scale = scale - .25;

      var transformations = "scale("+scale+")";
      $('g#outer-g').attr("transform", transformations);
    }
  }


  /* DRAG */
  function dragstarted() {
    dragTranslateX = d3.event.sourceEvent.offsetX,
    dragTranslateY = d3.event.sourceEvent.offsetY;
    // set translate here as well
    currentTranslatedX = storedXValue;
    currentTranslatedY = storedYValue;
    mouseDown();
  }

  function dragged() {
    if( ($(d3.event.sourceEvent.path[1]).attr('id') == 'counties') || ($(d3.event.sourceEvent.path[1]).attr('id') == 'svgContainer') ) {
      var dx = d3.event.sourceEvent.offsetX - dragTranslateX,
          dy = d3.event.sourceEvent.offsetY - dragTranslateY;

      storedXValue = currentTranslatedX + dx;
      storedYValue = currentTranslatedY + dy;

      calculatedXMovement = currentTranslatedX + dx;
      calculatedYMovement = currentTranslatedY + dy;

      var transformations = "translate(" + calculatedXMovement + " " + calculatedYMovement + ")";
      $('g.counties').attr("transform", transformations);
      $('g.state-borders').attr("transform", transformations);

      $('g.counties').attr("style","transform-origin: center center;");
      $('g.state-borders').attr("style","pointer-events: none; transform-origin: center center;");
    }
  }

  function hovering(d){
    var text = "";
    className = '';
    if(d.properties.community !== undefined){
      className = 'community__' + d.properties.community.toLowerCase().replace(/ /g, '-');
     
      text += "<span class=\"topic\">" + d.properties.community +"</span>";
    }

    if( (communityDescriptions[d.properties.community+' Description'] !== null) && (communityDescriptions[d.properties.community+' Description']!== undefined) ) {
      text += "<p>" + communityDescriptions[d.properties.community+' Description'] + "</p>"
    }

    if(d.properties.name !== undefined){
      text += " <h3>" + d.properties.name +"</h3>";
    }
    
    $('#tooltip').removeClass().addClass('tooltip ' + className);
    $('#tooltip').html(text);
    $xPos = 10;

    if( currentMousePos.x >= ($(window).width()/2) ) {
      $xPos = -600;
    }

    $('#tooltip').css({"top":currentMousePos.y - 1200,"left":currentMousePos.x + $xPos});
  }

  function hompageToggles() {
    if(isHomePage) {
      $('#zoom-in').click(function(){ zoomIn(); });
      $('#zoom-out').click(function(){ zoomOut(); });

      /*
      * For IE and Firefox only
      */
      $('#pan-right').click(function(){ mapright(); });
      $('#pan-left').click(function(){ mapleft(); });
      $('#pan-up').click(function(){ mapup(); });
      $('#pan-down').click(function(){ mapdown(); });
    }
  }

  function mouseDown() {
    $('#tooltip').attr( "style","display: none;" );
  }

  function mouseUp() {
    $('#tooltip').removeAttr( "style");
  }

  function homepageMapNavigation() {
    $('#homepage__map-navigation a').each(function(){
        $(this).click(function(e){
          if ($(window).width() >= 900) {
            e.preventDefault();

            if($(this).parent().hasClass('active')) {
              $(this).parent().toggleClass('active',false);
              $('#counties').attr("class","counties");
            }
            else {
              $('#homepage__map-navigation li').toggleClass('active', false);
              $(this).parent().toggleClass('active', true);
              var community = $(this).text().toLowerCase().replace(/ /g, '-');
              $('#counties').attr("class","counties low-fi " + community);

              $('html,body').animate({scrollTop: $('#svgContainer').offset().top - 100},'slow');
            }
          }
        });
    });
  }

  /*
  *   Map Directionals (For IE and Firefox only)
  */

  var vertical = 0,
      horizontal = 0;

  function mapright() {
    horizontal = horizontal - 50;
    move(horizontal,vertical);
  }

  function mapleft() {
    horizontal = horizontal + 50;
    move(horizontal,vertical);
  }

  function mapup() {
    vertical = vertical + 50;
    move(horizontal,vertical);
  }

  function mapdown() {
    vertical = vertical - 50;
    move(horizontal,vertical);
  }

  function move(h,v) {
    $('g.counties').attr("transform","translate("+h+" "+v+")");
    $('g.state-borders').attr("transform","translate("+h+" "+v+")");
  }

  $(document).mousemove(function(event) {
    currentMousePos.x = event.pageX;
    currentMousePos.y = event.pageY;
  });

  var init = function(){
      d3EachMap();
      homepageMapNavigation();
      hompageToggles();
  }
  init();
});